/**
 * CreateBrandModal のフォーム値と、サイトからの提案を当てる純粋関数 (Fast Refresh のためコンポーネントと別ファイル)。
 */
import type { SiteProposalResult } from '../../../features/brands/siteProposal';

export interface CreateBrandForm {
  brand_name: string;
  brand_code: string;
  tagline: string;
  description: string;
}

/** 提案の名前 / ブランドコード / タグライン / 説明で、空の欄だけ埋める (入力済みは据え置き) */
export function fillEmptyIdentity(form: CreateBrandForm, result: SiteProposalResult): CreateBrandForm {
  const id = result.identity;
  if (!id) return form;
  return {
    ...form,
    brand_name: form.brand_name.trim() ? form.brand_name : (id.brand_name ?? '').trim(),
    brand_code: form.brand_code.trim() ? form.brand_code : (id.brand_code ?? '').trim(),
    tagline: form.tagline.trim() ? form.tagline : (id.tagline ?? '').trim(),
    description: form.description.trim() ? form.description : (id.description ?? '').trim(),
  };
}

